import useLenis from "../components/useLenis";
import CommunityHero from "./CommunityHero";
import CommunityImpact from "../components/Home/CommunityImpact";
import CommunityMap from "../components/Home/CommunityMap";
import BePartOfTheMap from "../components/Home/BePartOfTheMap";
import CTAsec from "../components/Home/CTAsec";
import Footer from "../components/Home/Footer";

export default function CommunityPage() {
  useLenis();
  return (
    <>
      <CommunityHero />
      <CommunityMap />
      <BePartOfTheMap />
      <CommunityImpact showCta={false} />
      <CTAsec />
      <Footer />
    </>
  );
}
